export default {
    title: "O-I",
    support: "Apoyo",
    dashboard: "Panel"
}